import React from 'react';
import GeneralContain from '../../../Componant/Widgets/General';

const GeneralWidgets = () => {
  return (
    <div className='page-body'>
      <GeneralContain />
    </div>
  );
};

export default GeneralWidgets;
